import React from 'react'
import { useMsal } from '@azure/msal-react'
import { useTranslation } from 'react-i18next'

const UnAuthorizePage = () => {
  const { instance } = useMsal()
  const { t } = useTranslation(['translation'])
  const logout = () => {
    instance.logoutRedirect()
  }
  return (
    <div
      style={{
        display: 'contents',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h1
        className="text-primary p-5"
        style={{
          textAlign: 'center',
        }}
      >
        {t('common.un_authorized_msg')}
      </h1>
      <button
        className="btn btn-primary btn-block mb-5 text-uppercase"
        onClick={logout}
        style={{
          width: 'fit-content',
          alignSelf: 'center',
        }}
      >
        {t('common.logout')}
      </button>
    </div>
  )
}

export default UnAuthorizePage
